import { useSWRConfig } from "swr";

export function useRevalidateCache() {
  const { cache, mutate } = useSWRConfig();
  return () => {
    if (!(cache instanceof Map)) {
      throw new Error(
        "matchMutate requires the cache provider to be a Map instance",
      );
    }

    const mutations: Promise<any>[] = [];

    Array.from(cache).forEach(([key]) => {
      mutations.push(mutate(key));
    });

    return Promise.all(mutations);
  };
}
